/**
 * 全局语言入口：加载 i18n（shared/i18n），antd/dayjs 随语言切换。
 * admin 与 user 两个入口都 import 本文件。admin 目前仍固定中文。
 */
import zhCN from 'antd/locale/zh_CN';
import './i18n';

export const antdLocale = zhCN; // admin 入口固定中文
export default zhCN;
